async function loadSDK(d, s, id) {
    let js, fjs = d.getElementsByTagName(s)[0]

    if (d.getElementById(id)) return

    js = d.createElement(s)
    js.id = id
    js.src = 'https://connect.facebook.net/pt_BR/sdk.js'
    fjs.parentNode.insertBefore(js, fjs)
}

async function initLogin(applicationID, version = 'v23.0') {
    // window.fbAsyncInit = () => window.FB.init({ appId: applicationID, cookie: true, version: version, xfbml: true, })

    window.fbAsyncInit = function() {
        window.FB.init({
          appId      : applicationID,
          cookie     : true,
          xfbml      : true,
          version    : 'v23.0'
        });
          
        FB.AppEvents.logPageView();   
      };
    
}

/**
 * @param {function} callback
 * @param configs
 * @returns {Promise<boolean>}
 */
async function executeLogin(callback, configs) {
    if (configs instanceof Array) {
        configs = { scope: configs.join(',') }
    }

    window.FB.login(response => callback(response), configs)

    return false
}

export { loadSDK, initLogin, executeLogin }
